
import { defineComponent } from "vue"
import CardDrawRecordsIndex from "@/components/card_draw_records/Index.vue"

export default defineComponent({
  components: {
    CardDrawRecordsIndex
  }
})
